var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMobileCircle(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24.182,
    height: 24.182,
    viewBox: "0 0 24.182 24.182",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_25198",
    "data-name": "Group 25198",
    transform: "translate(-47 -240.409)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_24799",
    "data-name": "Group 24799",
    transform: "translate(0 -1094)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_24403",
    "data-name": "Group 24403",
    transform: "translate(-1188.999 1012.5)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1545",
    "data-name": "Ellipse 1545",
    cx: 12.091,
    cy: 12.091,
    r: 12.091,
    transform: "translate(1235.999 321.909)",
    fill: "#396"
  })), /*#__PURE__*/React.createElement("g", {
    id: "cell-phone",
    transform: "translate(49.375 1340)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7339",
    "data-name": "Path 7339",
    d: "M12.764,0H6.956a1,1,0,0,0-1,1.006V12.8a1,1,0,0,0,1,1h5.808a1,1,0,0,0,1-1V1.006A1,1,0,0,0,12.764,0ZM8.427.611h2.867c.072,0,.131.108.131.242s-.059.242-.131.242H8.427C8.354,1.1,8.3.987,8.3.853S8.354.611,8.427.611Zm1.434,12.2a.641.641,0,1,1,.64-.642A.642.642,0,0,1,9.86,12.813Zm3.156-2.2H6.7V1.7h6.312v8.918Z",
    transform: "translate(0)",
    fill: "#fff"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobileCircle);
export default __webpack_public_path__ + "static/media/mobile-circle.2d55a7300af3956f17e61a8bc41e4767.svg";
export { ForwardRef as ReactComponent };